import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ChatAuthService } from '../services/chat-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ChatAuthGuard implements CanActivate {

  constructor(
    private authService: ChatAuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    // Redirect to auth page
    this.router.navigate(['/milo/auth']);
    return false;
  }
}
